import React from 'react'
import classNames from 'classnames'
import { Button } from 'shared/ui/Button/ui/Button'
import styles from '../styles.module.scss'

type IButtonEditProps = {
  show?: boolean
  tag?: 'button' | 'div'
  text?: string
  onClick: () => void
}

export const ButtonEdit: React.FC<IButtonEditProps> = ({
  show = true,
  tag = 'button',
  text = 'Update',
  onClick,
}) => {
  return (
    <div
      className={classNames(styles.rightIcon, {
        [styles.hidden]: !show,
      })}
    >
      <Button
        tag={tag}
        icon='edit'
        text={text}
        typeBtn='contained'
        contained='tertiary'
        size='small'
        onClick={onClick}
      />
    </div>
  )
}
